var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_navigation"},_vm._l((_vm.links),function(link){return _c('router-link',{key:link.link,staticClass:"page_navigation__link fw500 text-gray fz14",class:{'router-link-active': _vm.$route.path.indexOf(link.link) >=0},attrs:{"to":link.link}},[_vm._v(_vm._s(link.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }